import { useAuth } from '@ev-tech/user-account-modules';

import { useListing } from '@/hooks/queries/useListing';

export const useShouldHideUserAccountExclusiveContent = (): boolean => {
  const { isSignedIn, isLoaded } = useAuth();
  const {
    data: { userAccountExclusiveListing },
  } = useListing();

  // Keep the exclusive variant hidden until auth confirms the user is signed in.
  return Boolean(userAccountExclusiveListing && (!isLoaded || !isSignedIn));
};
